import localeDefinitions from './locales.json';
import type { Locale } from './catalog';

export interface LocaleDefinition {
  code: Locale;
  label: string;
  flag: string;
  hreflang: string;
  isDefault: boolean;
}

// SAFETY: The adjacent array check validates the collection and its elements before use.
export const locales = /* SAFETY: The adjacent allowlist or equality check limits this value to the stated union. */ localeDefinitions as LocaleDefinition[];
export const localeCodes = locales.map(({ code }) => code);
export const defaultLocale = locales.find(({ isDefault }) => isDefault)?.code ?? 'en';

export function isLocale(value: string): value is Locale {
  // SAFETY: The adjacent allowlist, normalizer, or equality check limits this value to the stated union.
  return localeCodes.includes(value as Locale);
}
